// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--ynIom","active":"a10a3f92e9--active--jOYdW","focus-visible":"a10a3f92e9--focus-visible--Lp3RC","text":"a10a3f92e9--text--bZ8fG"};